<template lang="pug">
#changeLang.modal.modal-common.animated.fadeInUp1.modal-bottom(tabindex="-1" role="dialog" aria-labelledby="langLabel" aria-hidden="true")
  .modal-dialog.modal-dialog-scrollable.m-0(role="document")
    .modal-content
      .modal-header(data-dismiss="modal" :aria-label="$t('ui.cancel')")
        .icon
          i.fas.fa-arrow-left
        h5#exampleModalLabel.modal-title {{ $t("ui.display_language") }}
      .modal-body.p-0
        ul.list-group.setting(v-for="item in languageList")
          li.list-group-item(:class="{ active: (item == language) }" @click="setLanguage(item)")
            span.lang-pic
              img(:src="'/images/lang/' + item + '.svg?v=12'")
            span {{ $t("language." + item) }}
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";

export default {
  data() {
    return {
      languageList: ["en", "cn", "vi", "th", "id", "kr", "jp"]
    };
  },
  computed: {
    language() {
      return this.$store.getters.language;
    }
  },
  methods: {
    setLanguage(lang) {
      this.$store.dispatch("layout/setLanguage", lang);
      EventBus.$emit("INVALIDATE");
      $("#changeLang").modal("hide");
    }
  }
}
</script>